import { Button, Stack } from '@mui/material'
import { useAtom } from 'jotai'
import { typeAtom } from './atoms'


const TypeButton = ({ type }) => {
    const [selectedType, setSelectedType] = useAtom(typeAtom)

    return (
        <Button
            variant={type === selectedType ? "contained" : "outlined"}
            size="large"
            color="indigo"
            onClick={() => setSelectedType(type)}
            sx={{
                fontSize: 20,
                fontWeight: 700,
                borderRadius: 0,
                width: '100%',
                py: .5,
            }}
        >
            {type}
        </Button>
    )
}

const TypeTab = () => {

    return (
        <Stack
            direction="row"
            columnGap={0.5}
            width="100%"
            sx={{
                display : { md : "flex", xs : "none" },
            }}
        >
            <TypeButton
                type="経営者"
            />
            <TypeButton
                type="担当者"
            />
        </Stack>
    )
}

export default TypeTab
